<header class="header" [class.header--open]="isMenuOpen()">
  <div class="header__logo">
    <button class="header__logo-button">
      <a routerLink="/">
        <img class="header__logo-img" src="resources/img/icons/homeButton.png" alt="Ibercon logo" />
      </a>
    </button>
  </div>

  <nav class="header__bar">
    <app-nav-bar class="header__bar-routes" />
    <app-tool-bar class="header__bar-tools" [isMenuOpen]="isMenuOpen()" (toggleMenu)="onToggleMenu($event)" />
  </nav>
</header>

@if (isMenuOpen()) {
  <div class="header__menu-panel" @scrollOpen id="main-menu">
    <app-nav-menu class="header__menu" />
  </div>
}
